import PortalIdParser from 'PortalIdParser';
export function getFormsV2RoutePrefix() {
  const portalId = PortalIdParser.get();
  return `/submissions/${portalId}/form`;
}
export const getSubmissionsRoute = (guid, tab = 'SUBMISSIONS', usePrefix = true) => {
  const prefix = usePrefix ? `${getFormsV2RoutePrefix()}/` : '/form/';
  if (tab === 'PERFORMANCE') {
    return `${prefix}${guid}/performance`;
  } else if (tab === 'ANSWERS') {
    return `${prefix}${guid}/analyze`;
  }
  return `${prefix}${guid}/submissions`;
};
export const getPerformanceRoute = guid => getSubmissionsRoute(guid, 'PERFORMANCE');
export const getCMSRoute = () => `/website/${PortalIdParser.get()}/pages/site/all`;
export const getCallsToActionRoute = () => `/calls-to-action/${PortalIdParser.get()}`;
export function getCollectedFormsSettingsPage() {
  const portalId = PortalIdParser.get();
  return `/settings/${portalId}/marketing/form/non-hubspot`;
}